import styled from "styled-components";

import { ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS, PANEL_TRANSITION_MS, PANEL_Z_INDEX } from "./constants";

type AnimatedPanelMountProps = {
    readonly $x: number;
    readonly $y: number;
    readonly $shouldAnimatePosition: boolean;
};

export const AnimatedPanelMount = styled.div<AnimatedPanelMountProps>`
    position: fixed;
    left: ${({ $x }) => $x}px;
    top: ${({ $y }) => $y}px;
    z-index: ${PANEL_Z_INDEX};
    transform: translate3d(0, 0, 0);
    transform-origin: bottom right;
    ${({ $shouldAnimatePosition }) =>
        $shouldAnimatePosition
            ? `
                transition:
                    left ${ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1),
                    top ${ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
            `
            : ""}

    &.onboarding-agent-panel-enter {
        opacity: 0;
        transform: translate3d(0, 10px, 0) scale(0.97);
    }
    &.onboarding-agent-panel-enter-active {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1);
        transition:
            opacity ${PANEL_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1),
            transform ${PANEL_TRANSITION_MS}ms cubic-bezier(0.22, 1, 0.36, 1);
    }
    &.onboarding-agent-panel-exit {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1);
    }
    &.onboarding-agent-panel-exit-active {
        opacity: 0;
        transform: translate3d(0, 8px, 0) scale(0.98);
        transition:
            opacity ${PANEL_TRANSITION_MS}ms ease-in,
            transform ${PANEL_TRANSITION_MS}ms ease-in;
    }
`;
